import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-auth-intro',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './app-auth-intro.html'
})
export class AppAuthIntro {
    @Input() title: string = '';
    @Input() subtitle: string = '';
    @Input() badge: string = '';
    @Input() actionText: string = '';
    @Input() actionSubtext: string = '';
    @Input() tip: string = '';
    @Input() actionFn: () => void = () => { };
}
